import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

const BulkDeleteConfirmModal = (props: any) => {
  const {
    mediaType,
    numberSelectedMedia,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    onDeletePhotos,
  } = props;

  return (
    <>
      <Dialog
        maxWidth={'xs'}
        fullWidth={false}
        open={isDeleteModalOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-content"
      >
        <DialogTitle id="alert-dialog-title" className="bmls_dialog_title">
          {`Delete Selected ${mediaType} (${numberSelectedMedia})`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-content"
            className="bmls_dialog_content"
          >
            {`Are you sure you want to delete all of the selected ${mediaType.toLowerCase()}? This cannot be undone.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'start', ml: 2 }}>
          <Button
            variant="contained"
            className="bmls_btn"
            onClick={onDeletePhotos}
            color="error"
          >
            Delete All
          </Button>
          <Button
            className="bmls_btn"
            onClick={() => setIsDeleteModalOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BulkDeleteConfirmModal;
